import { RowFirmwareDto } from "@/dtos";
import { Firmware } from "@/entities";

export const formatTableFirmwareDto = async (firmware: Firmware[]): Promise<RowFirmwareDto[]> => {
    return firmware.map((x) => {
        const row: RowFirmwareDto = {
            ...x,
            active: x.is_active ? 'Activo' : 'Inactivo',
        }
        return row;
    });
}